import {Decoder, field, nullable, number, object, string} from 'json-bouncer'

export interface Position {
    id: number
    orderId: number
    productId: number
    name: string
    amount: number
    weight: number
    totalGrossPrice: number | null
    totalNetPrice: number | null
}

export function positionDecoder(): Decoder<Position> {
    return object({
        id: field('id', number()),
        orderId: field('orderId', number()),
        productId: field('productId', number()),
        name: field('name', string()),
        amount: field('amount', number()),
        weight: field('weight', number()),
        totalGrossPrice: field('totalGrossPrice', nullable(number())),
        totalNetPrice: field('totalNetPrice', nullable(number())),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/Position.ts